import OfficeService from '../services/office.service';
import { observable, action, computed } from 'mobx';

class OfficesStore {
  offices = observable([]);

  @action
  async fetchOffices() {
    if (this.offices.length) {
      return this.offices;
    }

    try {
      const items = await OfficeService.fetchOffices();

      if (items.isEmpty) {
        return null;
      }

      this.offices.push(...items.items);
      return this.offices;
    } catch (e) {
      console.error('Failed to fetch offices data');
      return null;
    }
  }

  @computed
  get polishOffices() {
    return this.offices.filter(o => o.country.iso2 === 'PL');
  }

  @computed
  get abroadOffices() {
    return this.offices.filter(o => o.country.iso2 !== 'PL');
  }

  @computed
  get countCountries() {
    const countries = new Set(this.offices.map(office => office.country.name));

    return countries.size;
  }

  getOfficeByID(id) {
    return this.offices.find(o => o.id === id);
  }
}

export default new OfficesStore();



// WEBPACK FOOTER //
// ./src/stores/Offices.store.js